export interface CallsPageSelection {
  groupKey: string | null;
  callId: string | null;
}

interface SelectableCall {
  id: string;
}

interface SelectableCallGroup {
  key: string;
  calls: SelectableCall[];
}

export function resolveCallsPageSelection(
  groups: SelectableCallGroup[],
  requestedCallId?: string,
  persisted?: CallsPageSelection | null,
): CallsPageSelection {
  const persistedCallGroup = persisted?.callId
    ? findCallGroup(groups, persisted.callId)
    : undefined;
  if (persistedCallGroup) {
    return {
      groupKey: persistedCallGroup.key,
      callId: persisted!.callId,
    };
  }

  const persistedGroup = persisted?.groupKey
    ? groups.find((group) => group.key === persisted.groupKey)
    : undefined;
  if (persistedGroup) {
    return {
      groupKey: persistedGroup.key,
      callId: null,
    };
  }

  const requestedGroup = requestedCallId
    ? findCallGroup(groups, requestedCallId)
    : undefined;
  if (requestedGroup) {
    return {
      groupKey: requestedGroup.key,
      callId: requestedCallId ?? null,
    };
  }

  return {
    groupKey: groups[0]?.key ?? null,
    callId: null,
  };
}

function findCallGroup(groups: SelectableCallGroup[], callId: string) {
  return groups.find((group) =>
    group.calls.some((call) => call.id === callId)
  );
}
